import { useSupabaseTable } from './useSupabaseTable';

export function useSolicitacoes() {
  return useSupabaseTable('solicitacoes', { orderBy: 'created_at', ascending: false });
}
